import { Component, EventEmitter, Input, OnChanges, OnDestroy, OnInit, Output, SimpleChanges } from '@angular/core';
import { FormControl } from '@angular/forms';
import { DateAdapter, MAT_DATE_FORMATS, MAT_DATE_LOCALE } from '@angular/material/core';
import moment from 'moment';
import { CustomDateAdapter } from '../../utils/custom-date-picker';

const MY_FORMATS = {
  parse: {
    dateInput: 'MM',
  },
  display: {
    dateInput: 'DATE_SELECTED',
    monthYearLabel: 'MMM YYYY',
    dateA11yLabel: 'LL',
    monthYearA11yLabel: 'MMMM YYYY',
  },
};

@Component({
  selector: 'app-custom-date-picker-week',
  templateUrl: './custom-date-picker-week.component.html',
  styleUrls: ['./custom-date-picker-week.component.scss'],
  standalone: false,
  providers: [
    { provide: DateAdapter, useClass: CustomDateAdapter, deps: [MAT_DATE_LOCALE] },

    { provide: MAT_DATE_FORMATS, useValue: MY_FORMATS },
    { provide: MAT_DATE_LOCALE, useValue: 'fr' },
  ],
})
export class CustomDatePickerWeekComponent implements OnInit, OnChanges, OnDestroy {
  @Output() public dateSwitch = new EventEmitter<string>();

  @Output() public weekPicked = new EventEmitter<string>();

  @Input() public day: moment.Moment | undefined;

  @Input() public showArrows: boolean = true;

  @Input() public boxedArrows: boolean = true;

  @Input() public minDate: Date | undefined;

  @Input() public maxDate: Date | undefined;

  public date: FormControl = new FormControl();

  public isMinDateReached = false;

  public isMaxDateReached = false;

  constructor() {}

  ngOnInit() {
    this.date = new FormControl({ value: moment(this.day), disabled: true });
    this.checkDateBoundaries();
  }

  ngOnChanges(changes: SimpleChanges) {
    if (changes['day']) {
      this.date = new FormControl({ value: moment(this.day), disabled: true });
      this.checkDateBoundaries();
    }
  }

  dateSwitchFunc(type: string) {
    this.dateSwitch.emit(type);
  }

  dateIsPicked(event: any) {
    event.value.set({ hour: 12 });
    this.weekPicked.emit(event);
  }

  checkDateBoundaries() {
    if (this.day) {
      this.isMinDateReached = !!this.minDate && moment(this.day).isSameOrBefore(this.minDate, 'week');
      this.isMaxDateReached = !!this.maxDate && moment(this.day).isSameOrAfter(this.maxDate, 'week');
    }
  }

  public dateClass = (d: Date) => {
    if (!this.day) {
      return '';
    }
    const date = moment(d).format('YYYY-MM-DD');
    const start = moment(this.day).clone().startOf('isoWeek').format('YYYY-MM-DD');
    const end = moment(this.day).clone().endOf('isoWeek').format('YYYY-MM-DD');
    const isInWeek = date >= start && date <= end;

    return isInWeek ? 'week-selected' : '';
  };

  ngOnDestroy() {
    localStorage.setItem('date', 'null');
  }
}
